import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function NavLink({ data }) {
  const location = useLocation();
  const isActive = location.pathname.split("/").pop() === data.to;

  return (
    <Link to={data.to}>
      <div
        className={`flex items-center gap-3 my-3 px-5 py-3 transition-all duration-200 rounded-lg backdrop-blur-md ${
          isActive
            ? "bg-orange-600/10 text-orange-500 border-r-4 md:border-r-[6px] border-orange-500 font-semibold"
            : "hover:bg-white/10 text-gray-700 hover:text-orange-500"
        }`}
      >
        <span className="w-5 h-5 flex items-center justify-center">{data.icon}</span>
        <p className="capitalize text-sm md:text-base">{data.text}</p>
      </div>
    </Link>
  );
}